import React, { useMemo } from 'react';
// import { useParams } from 'react-router-dom';
import Topic1400Img from '../../../../../../assets/2025/topic1400/top_person.png';
import TopFlowers from '../../../../../../assets/2025/topic1400/top_flowers.png';
// import { useStore } from '../../../../store';
import VideoTranscript from '../../components/videoTranscript';

interface ISection1Props {
  settings: any;
}

const Section0: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  // const param = useParams();
  // const p_course = param.course || '';
  // const p_topic = param['*'] || 'welcome';
  // const { getParagraphState } = useStore();
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[0],
    [settings?.paragraphs]
  );
  React.useEffect(() => {
    const onPlay = () => {
      if (process.env.REACT_APP_HOST_TYPE === 'dev') {
        return;
      }
      const elem = document?.querySelector('#video1400');
      if (elem?.requestFullscreen) {
        try {
          elem.requestFullscreen();
        } catch (error) {
          console.log(error);
        }
        document
          ?.querySelector('#video1400')
          ?.removeEventListener('play', onPlay);
      }
    };
    document?.querySelector('#video1400')?.removeEventListener('play', onPlay);
    document
      ?.querySelector('#video1400')
      ?.addEventListener('play', onPlay, { passive: true });
    return () =>
      document
        ?.querySelector('#video1400')
        ?.removeEventListener('play', onPlay);
  }, []);
  return (
    <div className="course-landing">
      <div className="course-landing-content">
        <div className="course-landing-text">
          <div
            className="title"
            dangerouslySetInnerHTML={{
              __html: paragraphsSettings?.message,
            }}
          />
          <div
            className="description"
            dangerouslySetInnerHTML={{
              __html: paragraphsSettings?.description,
            }}
          />
          <div className="video-container">
            <video
              id="video1400"
              width="100%"
              controls
              autoPlay={process.env.REACT_APP_HOST_TYPE !== 'dev'}
            >
              <source
                src={paragraphsSettings?.landingVideo?.src}
                type="video/mp4"
              />
              Your browser does not support HTML video.
            </video>
            <VideoTranscript transcripts={paragraphsSettings.transcripts} />
          </div>
        </div>
        <div className="left-img ">
          <img className="person" src={Topic1400Img} alt="" />
          <img className="flowers" src={TopFlowers} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Section0;
